import { C1DisplayNameSkeleton } from 'components/core/display-name-details'
import { MinimalAPIError } from 'components/core/errors/api'
import {
    C1EntitlementDisplayName,
    C1EntitlementDisplayNameProps,
} from 'components/pages/entitlement/display-name/C1EntitlementDisplayName'
import { AppEntitlementInfoDrawer } from 'components/pages/explore/visibility/info-drawers/AppEntitlementInfoDrawer'
import { FC, useMemo } from 'react'
import { FormattedMessage } from 'react-intl'
import { getAppEntitlementApi } from 'redux_toolkit/entitlements'

export type C1EntitlementDisplayNameWithFetchProps = {
    entitlementId: string
    appId: string
    showDrawer?: boolean
    showTooltip?: boolean
} & Omit<C1EntitlementDisplayNameProps, 'entitlement'>

export const C1EntitlementDisplayNameWithFetch: FC<C1EntitlementDisplayNameWithFetchProps> = ({
    entitlementId,
    appId,
    showDrawer,
    showTooltip,
    ...rest
}) => {
    const { data, error, isLoading, isError } = getAppEntitlementApi.useGet(
        {
            appId,
            id: entitlementId,
            expandMask: { paths: ['*'] },
        },
        { actionable: !!entitlementId },
    )

    const drawerContent = useMemo(
        () => (showDrawer && data
            ? <AppEntitlementInfoDrawer entitlement={data} />
            : undefined),
        [showDrawer, data],
    )

    if (isLoading) {
        return <C1DisplayNameSkeleton />
    }

    if ((isError && error) || !data) {
        return <MinimalAPIError
            err={<FormattedMessage id="component_api_error_entitlement" defaultMessage="Error fetching entitlement" />}
        />
    }

    return <C1EntitlementDisplayName
        {...rest}
        entitlement={data}
        drawerContent={drawerContent}
        showTooltip={showTooltip}
    />
}
